export const XP_LEVEL_MAPPING = {
    10: 1,      
    32: 2,      
    178: 3,     
    492: 4,     
    1010: 5,    
    1764: 6,    
    2782: 7,    
    4091: 8,    
    5712: 9,    
    7668: 10,   
    9978: 11,   
    12663: 12,  
    15740: 13,  
    19227: 14,  
    23141: 15,  
    27497: 16,  
    32311: 17,  
    37599: 18,  
    43375: 19,  
    49652: 20,  
    56446: 21,  
    63768: 22,  
    71633: 23,  
    80053: 24,  
    89040: 25,  
    98607: 26,  
    108765: 27, 
    119527: 28, 
    130903: 29, 
    142906: 30, 
    155546: 31, 
    168834: 32, 
    182781: 33, 
    197397: 34, 
    212693: 35, 
    228679: 36, 
    245365: 37, 
    262761: 38, 
    280876: 39, 
    299721: 40, 
    319305: 41, 
    339638: 42, 
    360728: 43, 
    382584: 44, 
    405217: 45, 
    428635: 46, 
    452846: 47, 
    477860: 48, 
    503685: 49, 
    530330: 50, 
    557803: 51, 
    586113: 52, 
    615268: 53, 
    645276: 54, 
    676146: 55, 
    707885: 56, 
    740502: 57, 
    774004: 58, 
    808400: 59, 
    843696: 60, 
    879902: 61, 
    917024: 62, 
    955070: 63, 
    994048: 64, 
    1033965: 65, 
    1074829: 66, 
    1116647: 67, 
    1159426: 68, 
    1203174: 69, 
    1247897: 70, 
    1293603: 71, 
    1340300: 72, 
    1387993: 73, 
    1436690: 74, 
    1486399: 75, 
    1537125: 76, 
    1588876: 77, 
    1641659: 78, 
    1695480: 79, 
    1750346: 80, 
    1806263: 81, 
    1863239: 82, 
    1921280: 83, 
    1980393: 84, 
    2040583: 85, 
    2101858: 86, 
    2164224: 87, 
    2227687: 88, 
    2292254: 89, 
    2357931: 90, 
    2424724: 91, 
    2492640: 92, 
    2561684: 93, 
    2631864: 94, 
    2703185: 95, 
    2775652: 96, 
    2849274: 97, 
    2924054: 98, 
    3000000: 99,  
    3077117: 100,
    3155412: 101,
    3234890: 102,
    3315557: 103,
    3397419: 104,
    3480482: 105,
    3564752: 106,
    3650234: 107,
    3736935: 108,
    3824859: 109,
    3914013: 110,
    4004403: 111,
    4096034: 112,
    4188911: 113,
    4283040: 114,
    4378428: 115,
    4475079: 116,
    4572998: 117,
    4672192: 118,
    4772666: 119,
    4874426: 120,
    4977476: 121,
    5081822: 122,
    5187471: 123,
    5294426: 124,
    5402693: 125,
    5512278: 126,
    5623186: 127,
    5735422: 128,
    5848991: 129,
    5963900: 130,
    6080152: 131,
    6197754: 132,
    6316709: 133,
    6437025: 134,
    6558704: 135,
    6681754: 136,
    6806179: 137,
    6931983: 138,
    7059172: 139,
    7187752: 140,
    7317726: 141,
    7449101: 142,
    7581880: 143,
    7716070: 144,
    7851675: 145,
    7988699: 146,
    8127149: 147,
    8267028: 148,
    8408342: 149,
    8551095: 150,
    8695293: 151,
    8840940: 152,
    8988041: 153,
    9136601: 154,
    9286624: 155,
    9438116: 156,
    9591081: 157,
    9745524: 158,
    9901450: 159,
    10058863: 160,
    10217768: 161,
    10378169: 162,
    10540073: 163,
    10703482: 164,
    10868402: 165,
    11715824: 166,
    11889905: 167,
    12065528: 168,
    12242699: 169,
    12421422: 170,
    12601701: 171,
    12783542: 172,
    12966947: 173,
    13151922: 174,
    13338472: 175,
    13526600: 176,
    13716311: 177,
    13907610: 178,
    14100501: 179,
    14294988: 180,
    14491076: 181,
    14688769: 182,
    14888071: 183,
    15088987: 184,
    15291521: 185,
    15495678: 186,
    15701461: 187,
    15908876: 188,
    16117925: 189,
    16328615: 190,
    16540948: 191,
    16754929: 192,
    16970563: 193,
    17187853: 194,
    17406804: 195,
    17627420: 196,
    17849699: 197,
    18073650: 198,
    18300304: 199,
    20000000: 200,
}

/**
 * Maps XP amount to the corresponding level
 * @param {number} xpAmount - The XP amount to map
 * @returns {number} - The level corresponding to the XP amount
 */
export const getLevelFromXP = (xpAmount) => {
    // Handle invalid inputs
    if (!xpAmount || xpAmount < 0) return 1;

    // Get all XP requirements sorted in descending order
    const xpRequirements = Object.keys(XP_LEVEL_MAPPING)
        .map(xp => parseInt(xp))
        .sort((a, b) => b - a);

    // Find the highest level where XP requirement <= xpAmount
    for (const requiredXP of xpRequirements) {
        if (xpAmount >= requiredXP) {
            return XP_LEVEL_MAPPING[requiredXP];
        }
    }

    // If xpAmount is less than minimum, return level 1
    return 1;
};
